// extracted by mini-css-extract-plugin
export default {"root":"root--B_GTJ","extrasBtnText":"extrasBtnText--xbrKt","table":"table--uZHq8","editIconBtn":"editIconBtn--rxoGE","addIcon":"addIcon--LFCe4"};